module.exports = __webpack_public_path__ + "static/media/dark_en.8d9b5c3f.svg";